import axios from 'axios';
import { ChatSettings } from '@/types/chat';

const HUGGING_FACE_API = "https://api-inference.huggingface.co/models/mistralai/Mixtral-8x7B-Instruct-v0.1";

export const getModelResponse = async (message: string, settings: ChatSettings) => {
  try {
    const response = await axios.post(
      HUGGING_FACE_API,
      {
        inputs: message,
        parameters: {
          temperature: settings.temperature,
          max_tokens: settings.maxTokens,
          top_p: settings.topP,
          repetition_penalty: settings.repetitionPenalty,
        },
      },
      {
        headers: {
          Authorization: `Bearer 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`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data[0].generated_text;
  } catch (error) {
    console.error("Error calling Hugging Face API:", error);
    throw error;
  }
};